// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3jgRX","inlineContent":"_2ufc7","pageWrapper":"_3LL-w","root":"_1FOTJ"};